import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { computed, inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { MediaBreakpoints, MediaPlatform } from '../../types/enum';

@Injectable({
  providedIn: 'root',
})
export class MediaPlatformService {
  private readonly breakpointObserver = inject(BreakpointObserver);

  readonly platform: Signal<MediaPlatform> = toSignal(
    this.breakpointObserver.observe([MediaBreakpoints.desktop, MediaBreakpoints.tablet]).pipe(
      map((state: BreakpointState) => {
        if (state.breakpoints[MediaBreakpoints.desktop]) {
          return MediaPlatform.desktop;
        }
        if (state.breakpoints[MediaBreakpoints.tablet]) {
          return MediaPlatform.tablet;
        }
        return MediaPlatform.mobile;
      })
    ),
    { initialValue: MediaPlatform.mobile }
  );

  readonly isDesktop = computed(() => this.platform() === MediaPlatform.desktop);
  readonly isTablet = computed(() => this.platform() === MediaPlatform.tablet);
  readonly isMobile = computed(() => this.platform() === MediaPlatform.mobile);
  readonly isTabletMobile = computed(() => !this.isDesktop());

  /** >= 1700px */
  readonly isLargeDesktop: Signal<boolean> = toSignal(
    this.breakpointObserver.observe(MediaBreakpoints.largeDesktop).pipe(map(result => result.matches)),
    { initialValue: false }
  );
}
